import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RejectAccountComponent } from './reject-account.component';
import { FuseSharedModule } from '@fuse/shared.module';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';



@NgModule({
    declarations: [RejectAccountComponent],
    imports: [
        CommonModule,
        MatDialogModule,
        MatButtonModule,
        MatFormFieldModule,
        MatInputModule,
        MatRadioModule,
        FuseSharedModule
    ]
})
export class RejectAccountModule { }
